import { Suspense } from "react";

import classNames from "classnames";

import BlockContent from "@/components/BlockContent";
import Image from "@/components/Image";

const HeroContent = ({ type, poster, title, subtitle, body, bodyAppendix = null, ...props }) => {
  if (type === "straight") {
    return (
      <div className="hero-content-developer relative md:grid md:grid-cols-12 straight">
        <div className="hero-block-content col-span-5 flex flex-col">
          <div className="flex flex-col flex-1 md:items-center justify-center md:mr-8 md:px-6 py-8 md:py-10 md:text-center md:border-t md:border-b border-gray-300">
            {subtitle && (
              <span className="mb-1 text-xs uppercase font-medium text-gray-500">{subtitle}</span>
            )}
            <h2 className="text-3xl mb-3 font-semibold">{title}</h2>
            <div className="hidden md:block w-1/3 h-px mb-3 bg-gray-500"></div>

            <Image
              src={poster?.asset}
              className="h-full md:hidden mb-3"
              alt=""
              loading="lazy"
              sizes="calc(100vw - 32px)"
            />

            <BlockContent body={body} />

            {bodyAppendix && (
              <>
                <div className="h-4"></div>
                {bodyAppendix}
              </>
            )}
          </div>
        </div>
        <div className="poster hidden col-span-7 md:flex flex-col">
          <div className="flex-1">
            <Image
              src={poster?.asset}
              className="h-full"
              alt=""
              sizes="(min-width: 1140px) 597px, calc(47.35vw + 67px)"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames("hero-content relative flex flex-col md:grid md:grid-cols-12", type)}
    >
      <div className="poster col-span-7 flex flex-col">
        <div className="flex-1 md:mt-16">
          <Image src={poster?.asset} className="h-full" alt="" />
        </div>
      </div>
      <div className="hero-block-content col-span-5 flex flex-col">
        <div className="flex flex-col flex-1 items-center justify-center md:mx-12 md:mt-16 md:mb-32 m-4 text-center text-white font-light">
          <h2 className="text-2xl mb-3">{title}</h2>
          <div className="w-1/3 h-px mb-3 bg-gray-500"></div>
          <BlockContent body={body} />
        </div>
      </div>
    </div>
  );
};

export default HeroContent;
